import BaseDropdownButton from 'components/atoms/baseButton/dropdown';
import { useTranslation } from 'react-i18next';
import StarAIIcon from 'components/atoms/icons/star-ai-icon';
import ChevronBottom from 'components/atoms/icons/chevron-bottom';
import i18n from 'infrastructure/i18n';
import { typedObjectEntries } from 'infrastructure/functions/typed-object-entries';

import s from './styles.module.scss';

import type { TSnapshotSummaryType } from 'infrastructure/interfaces';
import type { FC, ReactNode } from 'react';

interface IDropdownItem {
  key: string;
  label: ReactNode;
  className?: string;
  dataCy?: string;
  disabled?: boolean;
  visible?: boolean;
  onClick?: (...args: any) => void;
}

export const SUMMARY_BUTTONS: Record<TSnapshotSummaryType, string> = {
  sms: i18n.t('patientSnapshot.smsLogs'),
  'clinical-note': i18n.t('patientSnapshot.clinicalNotes'),
  call: i18n.t('patientSnapshot.calls'),
  'reading-comments': i18n.t('patientSnapshot.readingComments'),
};

interface SummariesDropdownProps {
  setOpenModalIdx: (value: TSnapshotSummaryType | null) => void;
}

const SummariesDropdown: FC<SummariesDropdownProps> = ({ setOpenModalIdx }) => {
  const { t } = useTranslation();

  const dropdownItems: IDropdownItem[] = typedObjectEntries(
    SUMMARY_BUTTONS,
  ).map(([key, value], idx) => {
    return {
      key: idx.toString(),
      label: value,
      onClick: () => setOpenModalIdx(key),
    };
  });

  return (
    <BaseDropdownButton
      type="secondary"
      items={dropdownItems}
      label={t('patientSnapshot.aiSummary')}
      icon={<StarAIIcon className={s['ai-icon']} />}
      rightIcon={<ChevronBottom />}
      width={150}
      dropdownProps={{
        rootClassName: s.dropdown,
      }}
    />
  );
};
export default SummariesDropdown;
